import React from 'react'
import {FocusTrap} from 'focus-trap-react'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faCheck, faUpRightFromSquare} from '@fortawesome/free-solid-svg-icons'
import SaveMoneyTime from '../../assets/save-moneytime-cabana.svg'

export interface ExtendedStayModalProps {
  isOpen: boolean
  onClose: () => void
  allowMonthlyRates: boolean
}

const ExtendedStayModal = ({
  isOpen,
  allowMonthlyRates,
  onClose
}: ExtendedStayModalProps) => {
  const features = [
    'Weekly housekeeping on stays of 7+ night stays',
    'Skip the application fees',
    'Settle into fully furnished spaces with kitchens, in-unit laundry, and walkable locations',
    'Enjoy on-site amenities like rooftop lounges, pools, gyms, and more',
    'Count on 24/7 support from our Placemaker team'
  ]

  return (
    <>
      {isOpen && (
        <FocusTrap active={isOpen}>
          <div
            className="modal modal-open"
            onClick={e => {
              if (e.target === e.currentTarget) {
                onClose()
              }
            }}
            role="dialog"
            aria-modal="true"
          >
            <div className="modal-box p-0 max-w-screen-sm max-h-[95%]">
              <button
                className="btn btn-sm btn-circle btn-white absolute right-2 top-2"
                onClick={onClose}
                aria-label="Close unit details modal."
              >
                ✕
              </button>
              <div className="modal-body overflow-y-scroll pr-4 mt-2 px-8 py-4">
                <div className="flex flex-col gap-2">
                  <img
                    src={SaveMoneyTime}
                    alt="Save money time"
                    className="h-12 w-12"
                  />
                  <h1 className="text-xl font-semibold">
                    Stay Longer. Save More.
                  </h1>
                  <div className="flex flex-col gap-2 mt-4 mb-2">
                    <div className="text-sm">
                      <div className="font-semibold">Stay 7+ nights</div>
                      <div>
                        Save up to{' '}
                        <span className="font-semibold">
                          15% with our weekly rate.
                        </span>
                      </div>
                    </div>

                    {allowMonthlyRates && (
                      <div className="text-sm">
                        <div className="font-semibold">Stay 28+ nights</div>
                        <div>
                          Save up to{' '}
                          <span className="font-semibold">
                            30% with our monthly rate.
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="flex flex-col gap-2 mt-2 mb-4">
                    {features.map((feature, index) => (
                      <div
                        key={index}
                        className="flex flex-row items-center justify-start gap-3"
                      >
                        <FontAwesomeIcon
                          icon={faCheck}
                          className="text-accent text-md"
                        />
                        <span className="text-sm">{feature}</span>
                      </div>
                    ))}
                  </div>
                  <div className="flex flex-row items-center justify-center mt-4">
                    <a
                      className="link link-accent text-sm mx-auto"
                      href="https://www.placemakr.com/faq#extended-stay-faqs"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <span>See Extended Stay FAQs for more info</span>
                      <FontAwesomeIcon
                        icon={faUpRightFromSquare}
                        className="ml-2"
                      />
                    </a>
                  </div>
                  <div className="flex flex-row items-center justify-center my-4">
                    <p className="text-xs text-gray-500">
                      Amenities and in-unit features vary by property
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </FocusTrap>
      )}
    </>
  )
}

export default ExtendedStayModal
